/** PC 端導師入駐表單（join/components/pc） */
export default {
	title: "歡迎入駐SeerQ",
	page: {
		loading: "加載中...",
		submitting: "正在提交審核...",
		submitOk: "提交成功，等待審核",
		submitFail: "提交失敗，請重試",
		saving: "正在保存...",
		saveOk: "保存成功",
		saveFail: "保存失敗，請重試",
		mockOk: "測試數據已填充完成！",
		mockBtn: "一鍵填充測試數據",
	},
	actions: {
		back: "返回",
		backHome: "返回首頁",
		next: "下一步",
		submitReview: "提交審核",
	},
	common: {
		cancel: "取消",
		confirm: "確定",
	},
	submitConfirm: {
		title: "溫馨提示",
		message: "請確認所填寫信息是否正確，一經提交將不可修改！",
		cancel: "返回修改",
		confirm: "確認提交",
	},
	mentorForm: {
		language: "使用語言",
		languageM: "使用語言",
		languageOptions: {
			Mandarin: "華語",
			Cantonese: "粵語",
			English: "English",
			Other: "其他",
		},
		languagePh: "請選擇",
		otherLanguagePh: "請輸入您擅長的其他語言",
		stageName: "個人藝名",
		stageNamePh: "請輸入2~5個漢字",
		stageNameTip:
			"個人藝名是您入駐SeerQ後使用的官方名字，可以是真實名字，或者是您喜歡或熟悉的名字，請儘量不要使用難讀、難記、生僻字等。",
		englishName: "英文名",
		englishNamePh: "請輸入16字以內的英文名",
		gender: "性別",
		genderFemale: "女",
		genderMale: "男",
		genderOther: "其他",
		location: "所在地區",
		locationPh: "請選擇",
		email: "電子郵箱",
		emailPh: "請輸入可聯繫的郵箱",
		careerStartYear: "從業時間",
		careerStartYearM: "從業時間",
		careerStartYearPh: "請選擇您開始從業的時間",
		careerYearOption: "{year}年",
		referrer: "推薦人",
		referrerPh: "如有，請務必填寫",
		teacherCategory: "導師屬性",
		teacherCategoryM: "導師屬性",
		teacherCategoryPh: "請選擇",
		teacherSubCategoryPh: "請選擇（最多5個）",
		bestExpertise: "最擅長領域",
		bestExpertiseM: "最擅長領域",
		bestExpertisePh: "請選擇（最多3個）",
		proofImages: "從業與學習證明",
		proofImagesTip: "可以是培訓證明/個人案例/榮譽照片等，請點擊上傳，最多5張，每張大小限制2M以內",
		personalIntroduction: "個人介紹（不少於50字）",
		personalIntroductionPh:
			"個人介紹中建議包含自己的特點、經驗、榮譽、擅長的方向。\n示例：經過兩年系統的學習之後，在大量諮詢實戰中形成了獨到的分析體系，擅長情感、事業，財富規劃等分析，諮詢細緻，點評細致，因此獲得眾多客戶的一致好評，每天9點到20點在線，歡迎速麥諮詢。(請勿照抄示範例，否則將無法通過審核)",
		editorLoading: "編輯器加載中...",
		validateFail: "請檢查表單填寫是否正確",
		pickImage: "請選擇圖片文件",
		imageMax2mb: "圖片大小不能超過 2MB",
		uploadNoUrl: "上傳失敗：未返回圖片URL",
		uploadSuccess: "圖片上傳成功",
		uploadFail: "圖片上傳失敗",
		subCategoryMax: "二級下拉最多選擇5個",
		bestExpertiseMax: "最擅長領域最多選擇3個",
		rules: {
			language: "請選擇使用語言",
			otherLanguage: "請輸入您擅長的其他語言",
			stageName: "請輸入2~5個漢字的個人藝名",
			englishName: "請輸入16字以內的英文名",
			gender: "請選擇性別",
			location: "請選擇所在地區",
			email: "請輸入可聯繫的郵箱",
			emailFormat: "請輸入正確的郵箱格式",
			careerStartYear: "請選擇從業時間",
			teacherCategory: "請選擇導師屬性",
			teacherSubCategories: "請選擇導師屬性子項",
			bestExpertise: "請選擇最擅長領域",
			proofImages: "請上傳從業與學習證明",
			personalIntroduction: "請填寫個人介紹",
			personalIntroductionMin: "個人介紹不少於50字",
		},
	},
	listen: {
		title: "測試題",
		loading: "題目加載中...",
		noQuestions: "暫無測試題",
		fetchFail: "獲取測試題失敗，請重試",
		questionProgress: "第{current}題，共{total}題",
		noteTitle: "說明：",
		text1: "1、請模擬真實提問場景，結合擅長領域提取關鍵資訊並認真作答。",
		text2: "2、回答需邏輯清晰、有理有據，包含學術分析與明確結論。",
		text3: "3、每個問題僅可上傳 1 個錄音檔案，時長請控制在 60–300 秒。",
		text4:
			'4、完成後請上傳錄音檔案並提交。<span class="recording-guide-link">點擊查看《錄音操作手冊》</span>。',
		upload: "點擊上傳",
		uploading: "上傳中...",
		reupload: "點擊重新上傳",
		uploaded: "已上傳錄音",
		pickAudio: "請選擇音頻檔案",
		audioDuration: "錄音時長請控制在 60–300 秒",
		uploadNoUrl: "上傳失敗：未返回檔案地址",
		uploadSuccess: "錄音上傳成功",
		uploadFail: "錄音上傳失敗",
		uploadRequired: "請先上傳本題錄音後再繼續",
		allUploadRequired: "請完成所有題目的錄音上傳後再繼續",
	},
	question: {
		title: "調查問卷",
		dec: "本問卷用於入駐考核調研，所有問题沒有對錯之分，您只需要根據真實情沉進行回答即可，回答的所有問题均會進行保密虚理。感谢您的支持與配合!",
		loading: "問卷加載中...",
		noQuestions: "暫無問卷題目",
		fetchFail: "獲取問卷失敗，請重試",
		single: "單選題",
		multiple: "多選題",
		short: "簡答題",
		textareaPh: "請輸入內容",
		answerRequired: "請完成第{index}題",
		submitting: "提交中...",
		submitOk: "問卷提交成功",
		submitFail: "問卷提交失敗，請重試",
	},
	status: {
		download: "下载先知命局App",
		app: "See Beyond",
		back: "返回首頁",
		processing: {
			title: "導師資質認證中",
			dec1: "您的資料已提交審核，審核期間相關信息無法更改。",
			text1: "審核人員將於10個工作日內透過電子郵件回覆審核結果，敬請留意郵件收信。",
			text2: "另可下載先知命局App，即時接收審核進度與結果通知，感謝您的配合與支持。",
		},
		join: {
			title: "歡迎加入SeerQ",
			dec1: "您已成為 SeerQ 的签约導師， ",
			dec2: "歡迎前往先知命局 App 接單、為用戶答疑解惑。",
		},
		failed: {
			title: "很抱歉，您的老师资质审核暂未通过。",
			reason: "原因",
			dec: "您可根據審核意見修改資料後重新提交申請。",
			edit: "去修改",
		},
	},
};
